export default __webpack_public_path__ + "static/media/tf.aaea08de.svg";